/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 24/03/2025
*/

import React from 'react'
import { Button, Container, Grid, Typography } from '@mui/material';
import Styles from './productsIntro.module.css';
import ProductBackGround from '../../assets/images/product/productCover-BlackBox3.png';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';


const ECOMLITE = () => {

  return (

    <>
      <div className={Styles.topContentMainContainerEcomlite}>
        <img src={ProductBackGround} className={Styles.productCoverBlackBox} />
        <div className={Styles.topContentBox}>
          <Typography variant='h2' className={Styles.productTopHeader} >E-Commerce lite web</Typography>
          <Typography variant='h6' className={Styles.productTopBody}>Welcome to our specialized e-commerce platform. Discover a seamless online shopping experience like
            never before with our state-of-the-art e-commerce platform. Here, we strive to redefine the way you shop, offering
            an extensive range of products that cater to every need and desire.</Typography>
        </div>
      </div>

      <div className={Styles.outerContainer}>
        <Typography variant='h5' className={Styles.titelFirsttxt} >KEY FEATURES</Typography>
        <div className={Styles.descriptionContainer}>

          <div>
            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Stunning website</Typography>
                <Typography className={Styles.descriptionText}>
                  The design of your website plays a crucial role in attracting visitors. Use a clean and visually appealing layout, with a color scheme that matches your brand. Ensure your site is responsive, so it looks great on all devices.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>High-Quality Visuals</Typography>
                <Typography className={Styles.descriptionText}>
                  Use high-resolution images and videos to showcase your products or services. Professional visuals are essential to make a positive first impression.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>User-Friendly Navigation</Typography>
                <Typography className={Styles.descriptionText}>
                  Organize your website with a logical menu structure and easy-to-use navigation. Make it simple for visitors to find what they're looking for.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Search Engine Optimization (SEO)</Typography>
                <Typography className={Styles.descriptionText}>
                  Optimize your website for search engines to improve its visibility. Use relevant keywords, meta descriptions, and alt tags for images.
                </Typography>
              </div>
            </div>
          </div>

          <div>
            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Create Packages / Sets </Typography>
                <Typography className={Styles.descriptionText}>
                  Combine multiple products or services and create a unique packages or set for your clients.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Analytics and Reporting</Typography>
                <Typography className={Styles.descriptionText}>
                  Access actionable insights and reports that provide valuable data on customer behaviors, sales performance, marketing ROI, and more. Use this data to make informed business decisions and refine your strategies.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Customer Support</Typography>
                <Typography className={Styles.descriptionText}>
                  Provide excellent customer support through various channels (email, chat, phone) to assist users with inquiries and issues.
                </Typography>
              </div>
            </div>
          </div>


        </div>
      </div>
    </>




  );
}

export default ECOMLITE;